<template>
  <div class="wrapper">
    <btn :class="btnClasses" :color="color" :size="size" @click.native="buttonOnclick" :disabled="disabled" :icon="icon" :iconRight="iconRight" :flat="flat"><slot>{{ label }}</slot></btn>

    <modal v-if="modalState" @close="modalState=false">
      <modal-header class="bg-primary text-white">
        <modal-title>{{ confirmationTitle }}</modal-title>
      </modal-header>

      <modal-body>
        {{ confirmationText }}
      </modal-body>

      <modal-footer class="justify-content-center">
        <btn color="danger" @click.native="modalState=false">Nem</btn>
        <btn color="success" @click.native="buttonSuccess">Igen</btn>
      </modal-footer>
    </modal>
  </div>
</template>

<script>
import classNames from 'classnames'
import { Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, Btn } from 'mdbvue'

export default {
  components: {
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    Btn
  },

  props: {
    label: {
      type: String
    },

    color: {
      type: String,
      default: 'primary'
    },

    requireConfirmation: {
      type: Boolean,
      default: false
    },

    confirmationTitle: {
      type: String
    },

    confirmationText: {
      type: String
    },

    disabled: {
      type: Boolean,
      default: false
    },

    small: {
      type: Boolean,
      default: false
    },

    large: {
      type: Boolean,
      default: false
    },

    icon: {
      type: String,
      default: ''
    },

    flat: {
      type: Boolean,
      default: false
    },

    noMargin: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      modalState: false
    }
  },

  computed: {
    btnClasses () {
      return classNames(
        this.noMargin ? 'm-0' : ''
      )
    },

    size () {
      if (this.small) return 'sm'
      if (this.large) return 'lg'
      return ''
    },

    iconRight () {
      return this.icon !== ''
    }
  },

  methods: {
    buttonOnclick () {
      if (this.requireConfirmation) this.modalState = true
      else this.buttonSuccess()
    },

    buttonSuccess () {
      this.modalState = false
      this.$emit('click')
    }
  }
}
</script>

<style lang="stylus" scoped>
.wrapper
  display: inline-block
</style>



// WEBPACK FOOTER //
// src/plugins/formFields/eButton.vue